import React, { Component } from "react";
import "moment-timezone";

import ContactsService from '../utils/ContactsService'
import DealsService from '../utils/DealsService'

import Alert from 'react-s-alert';

import { Modal, Button } from 'react-bootstrap'
import AsyncSelect from 'react-select/lib/Async';

class AddContactModal extends Component {
  state = {}
  getContacts = (inputValue) => {
    return ContactsService.index({ text_filter: inputValue }).then((results) => {
      console.log(results.results.map((opt) => opt.id))
      return results.results.map((opt) => {
        return { value: opt.id, label: `${opt.contact_type}: #${opt.id}: ${opt.email || 'no email'} / ${opt.mobile || 'no mobile'} / ${opt.first_name || 'no name'}` }
      })
    })
  }

  valueChanged = (newValue) => {
    this.setState({ selectedValue: newValue})
  }

  addContact = () => {
    const { onConfirmModal, onCloseModal } = this.props
    DealsService.takeAction('add_contact', this.props.deal.id, { contact_id: this.state.selectedValue.value }).then(data => {
      Alert.success('Added')
      onConfirmModal(data)
      onCloseModal()
    });
  }

  render() {
    const { showModal, onCloseModal } = this.props
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Existing Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <AsyncSelect
          onChange={this.valueChanged}
          loadOptions={this.getContacts}
        />

          <div style={{ marginTop: 20 }}>
            <Button onClick={onCloseModal} bsSize='small'>Whoops, cancel this</Button>
            <Button className='pull-right' disabled={!this.state.selectedValue} bsStyle='success' bsSize='small' onClick={this.addContact}>Add This Contact to Deal</Button>
          </div>
        </Modal.Body>
      </Modal>)
  }
}

export default AddContactModal